var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternal)?_c('img',{style:({
    maxWidth: _vm.iconSize,
    height: 'auto',
    filter: _vm.getFilter,
  }),attrs:{"src":_vm.source.Logo,"alt":_vm.source.Name}}):_c('img',{style:(("width:" + _vm.iconSize + "; height:" + _vm.iconSize + "; filter: invert(" + (_vm.$vuetify.theme.dark ? 1 : 0) + ");")),attrs:{"src":("https://compcon-image-assets.s3.amazonaws.com/icons/" + (_vm.source.Logo) + ".svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }